export const oidcSettings = () => {

	switch(window.location.host) {
		case process.env.VUE_APP_HOST_EXTERNAL:
			return ExternalSettings;
		case process.env.VUE_APP_HOST_INTERNAL:
		default:
			return InternalSettings;	
	}
};

const InternalSettings = {
	authority: process.env.VUE_APP_AUTH_SERVER,
	clientId: 'vue-support-portal',
	redirectUri: `https://${process.env.VUE_APP_HOST_INTERNAL}/oidc-callback`,
	responseType: 'id_token token',
	scope:
		'openid vue.support.portal Vue.Support.Api Email SupportTech Role SupportPermission GlobalFirstName GlobalLastName',
		post_logout_redirect_uri: `https://${process.env.VUE_APP_HOST_INTERNAL}`,
		silentRedirectUri: `https://${process.env.VUE_APP_HOST_INTERNAL}/oidc-silent-renew`,
	automaticSilentRenew: true // If true oidc-client will try to renew your token when it is about to expire
};

const ExternalSettings = {
	authority: process.env.VUE_APP_AUTH_SERVER,
	clientId: 'vue-support-external',
	redirectUri: `https://${process.env.VUE_APP_HOST_EXTERNAL}/oidc-callback`,
	responseType: 'id_token token',
	scope:
		'openid vue.support.external Vue.Support.Api Email ExternalSupportTech Role SupportPermission SupportCustomer GlobalFirstName GlobalLastName',
	post_logout_redirect_uri: `https://${process.env.VUE_APP_HOST_EXTERNAL}`,
	silentRedirectUri: `https://${process.env.VUE_APP_HOST_EXTERNAL}/oidc-silent-renew`,
	automaticSilentRenew: true // If true oidc-client will try to renew your token when it is about to expire
};
